import { useState } from "react"
import OrdenCompraEnvioItem from "./OrdenCompraEnvioItem"


function OrdenCompraItem({ orden, canSeePedido, canSeeSensible }) {
    
  const [open, setOpen] = useState(true)

  const envios = Array.isArray(orden.entregas) ? orden.entregas : []
  
  return (
    <div className="ordenCompraItem column">
      <div className={`ordenCompraIheader row${open ? " ordenCompraIheader--abierto" : ""}`}>
        <i className="fa-solid fa-angle-right" onClick={() => setOpen(!open)}></i>
        <div><strong>OC: {orden.nroOrdenCompra}</strong></div>
        {canSeePedido && orden.nroPedido && <div>pedido: {orden.nroPedido}</div>}
        <div className="ordenCompraFecha">- emisión {new Date(orden.fEmision).toLocaleDateString("es-AR", { timeZone: "UTC" })}</div>
        {orden.fVencimiento && <div className="ordenCompraFecha">- vigente hasta {new Date(orden.fVencimiento).toLocaleDateString("es-AR", { timeZone: "UTC" })}</div>}
        <div>{orden.tipoPlazo}</div>
      </div>
      <div className={`ordenCompraIbody${open ? " ordenCompraIbody--abierto" : ""}`}>
          <div className="ordenCompraItitles row">
            <div>n° entrega</div>
            <div>estado</div>
            <div>fecha de entrega</div>
            <div>observaciones</div>
            <div>adjuntos</div>
            {canSeeSensible && <div><i className="fa-solid fa-circle-info" title="más información"></i></div>}
          </div>

          <div className="ordenCompraIentregas column">
            {envios.length === 0 ? (
              <div className="ordenCompraEnvioEmpty">No hay envíos registrados</div>
            ) : (
              envios.map((envio) => (
                <OrdenCompraEnvioItem key={envio.id} envio={envio} canSeeSensible={canSeeSensible} nroOrdenCompra={orden.nroOrdenCompra} />
              ))
            )}
          </div>
      </div>
    </div>
  )
}

export default OrdenCompraItem
